import React, { createContext, useState, } from 'react';

const FeatureUnlockContext = createContext();

export const FeatureUnlockProvider = ({ children }) => {
  const [unlockedFeatures, setUnlockedFeatures] = useState(() => {
    const saved = localStorage.getItem('unlockedFeatures');
    return saved ? JSON.parse(saved) : {};
  });

  const [featureDataCache, setFeatureDataCache] = useState(() => {
    const saved = localStorage.getItem('featureDataCache');
    return saved ? JSON.parse(saved) : {};
  });

  const unlockFeature = (featureKey, data) => {
    setUnlockedFeatures(prev => {
      const updated = { ...prev, [featureKey]: true };
      localStorage.setItem('unlockedFeatures', JSON.stringify(updated));
      return updated;
    });

    setFeatureDataCache(prev => {
      const updated = { ...prev, [featureKey]: data };
      localStorage.setItem('featureDataCache', JSON.stringify(updated));
      return updated;
    });
  };

  const resetUnlocks = () => {
    setUnlockedFeatures({});
    setFeatureDataCache({});
    localStorage.removeItem('unlockedFeatures');
    localStorage.removeItem('featureDataCache');
  };

  return (
    <FeatureUnlockContext.Provider
      value={{ unlockedFeatures, featureDataCache, unlockFeature, resetUnlocks }}
    >
      {children}
    </FeatureUnlockContext.Provider>
  );
};

export default FeatureUnlockContext;